<template>
  <div>
    <MainLayout>
      <div class="text-sm">Logout</div>
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';

export default {
  components: {
    MainLayout,
  },
};
</script>
